import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ModuleDetails = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [moduleDetail, setModuleDetail] = useState<any>(null);

  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("id");
  const { moduleId } = useParams<{ moduleId: string }>();
  const [record, setRecord] = useState<any>(null);
  
  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/record`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setRecord(data[0]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar detalles del expediente:", error);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!moduleId || !token || !userId) return;
    fetch(
      `https://has-backend-c48d669d897f.herokuapp.com/student/modules/${userId}/modules/${moduleId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (!response.ok)
          throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setModuleDetail(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar detalles del módulo:", error);
        setIsLoading(false);
      });
  }, [moduleId, token, userId]);

  const hasGuarantee = moduleDetail?.student?.guaranteePayment?.paid;
  const hasExtraordinary = moduleDetail?.student?.extraordinaryPayment?.paid;
  const progress = moduleDetail?.StudentProgress;
  console.log(progress?.status)
  const score = progress?.score ?? null;
  const passed = progress?.score >= 80;
  const reprobadoSinPago = score !== null && score < 80 && !hasGuarantee && !hasExtraordinary;
  const hasGuide = record?.canSeeGuide;

  return (
    <div className="flex flex-col items-center w-full px-4 py-6 bg-white">
      {isLoading || !moduleDetail ? (
        <p className="mt-20 text-lg text-center">Cargando detalles del módulo...</p>
      ) : (
        <div className="w-full max-w-screen-md">
          <h2 className="font-playfair font-bold text-2xl sm:text-4xl mt-6 mb-4 text-center">
            {moduleDetail.module.title}
          </h2>
          {hasGuide && (
            <>
            <h2 className="font-playfair font-bold text-2xl sm:text-3xl mt-10 mb-4 text-center">
              Guía de estudio
            </h2>

            <div className="w-full flex justify-center">
              <iframe
                src={`https://guiascontainer.s3.us-east-2.amazonaws.com/0${moduleDetail.module.week}.pdf`}
                className="w-full h-[80vh] border rounded-lg overflow-y-auto"
                style={{ WebkitOverflowScrolling: "touch", overflow: "auto" }}
                title="Guía del módulo"
              ></iframe>
            </div>

            <div className="text-center mt-2 mb-8">
              <a
                href={`https://guiascontainer.s3.us-east-2.amazonaws.com/0${moduleDetail.module.week}.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline text-sm"
              >
                Ver guía en nueva pestaña
              </a>
            </div>
            </>
          )}


          <h2 className="font-playfair font-bold text-2xl sm:text-3xl mt-6 mb-4 text-center">
            Evaluación
          </h2>
          <p className="font-sourceSans max-w-xl mx-auto text-center text-gray-700">

            Una vez que inicies esta evaluación, deberás completarla sin cerrar la pestaña del navegador. 
            Asegúrate de contar con conexión estable a internet. Si abandonas el examen antes de terminarlo, 
            se registrará como <span className="font-semibold text-red-600">no aprobado</span>.
          </p>

          {progress?.status === "locked" ? (
            <p className="text-red-600 font-sourceSans mt-4">
              Todavía no has pagado este módulo. Realiza el pago para acceder a la evaluación.
            </p>
          ) : reprobadoSinPago ? (
            <p className="text-red-600 font-sourceSans mt-4">
              Reprobaste esta evaluación. Debes pagar garantía o extraordinario para volver a intentarlo.
            </p>
          ) : passed ? (
            <p className="text-green-600 font-sourceSans mt-4">
              Ya pasaste este módulo.
            </p>
          ) : (
            <div className="flex justify-center">
              <button
                onClick={() => navigate(`/students/${userId}/modules/${moduleId}/evaluation`)}
                className="mt-6 mb-12 px-8 py-3 rounded-xl bg-gradient-to-r from-[#1c1c2e] to-[#3a3a5d] text-white font-semibold shadow-lg hover:scale-105 transition-transform duration-300"
              >
                Comenzar evaluación ahora
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ModuleDetails;


